module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_japa.61ed5516.png";